import axios from '../plugins/parseAxios'
export class AssetAPI {
    static getAsset(payload) {
        return axios.post("functions/getAsset", payload)
    }
    static getAssets(payload) {
        return axios.post("functions/getAssets", payload)
    }
    static updateAsset(payload) {
        return axios.post("functions/updateAsset", payload)
    }
    static removeAsset(payload) {
        return axios.post("functions/removeAsset", payload)
    }
    static createAsset(payload) {
        return axios.post("functions/createAsset", payload)
    }
}